import { useQuery } from "@tanstack/react-query";
import vehiclesList from "Api/vehicles/list";
import { JobsRequestList } from "Services/Job/job";

export function useVehicles(params: any) {
  const query = () => vehiclesList(params);

  return useQuery(["vehiclesList", ...Object.values(params)], query);
}
